import { withQuery } from 'ufo'
import { extractPageFromRoute } from '~/lib/routing'

interface usePaginationPLPOptions {
  pages: Ref<number>
}

export function usePaginationPLP(options: usePaginationPLPOptions) {
  const route = useRoute()
  const { pathWithoutPage } = extractPageFromRoute(route)
  const { pages } = options

  const { page: pageFromUrl } = extractPageFromRoute(route)

  const page = ref(pageFromUrl)

  const isEmpty = computed(() => pages.value < 1)

  const nextPageUrl = computed(() => {
    const nextPage = page.value + 1
    const nextOrLastPage = Math.min(nextPage, pages.value)
    const nextPageUrl = withQuery(`${pathWithoutPage}/${nextOrLastPage}`, route.query)
    return nextPageUrl
  })

  const prevPageUrl = computed(() => {
    const prevPage = page.value - 1
    const prevOrFirstPage = Math.max(prevPage, 1)
    const prevPageUrl = withQuery(`${pathWithoutPage}/${prevOrFirstPage}`, route.query)
    return prevPageUrl
  })

  return {
    // State
    page,

    // Computed
    isEmpty,
    nextPageUrl,
    prevPageUrl,
  }
}
